module.exports = __webpack_public_path__ + "static/media/circle-pause.b549c17b.svg";